/**
 * Module dependencies.
 */

import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { AxiosInstance } from 'axios';
import { useQuery } from '@tanstack/react-query';
import { CCICode } from 'app/types/cci';

/**
 * Get cci codes
 */

export function getCCICodes(client: AxiosInstance, search: string | undefined): Promise<CCICode[]> {
  return client
    .get(resolveAppUrl('ccisCodes', { params: { filters: { search } } }), { withCredentials: true })
    .then(({ data }) => data?.data);
}

/**
 * Export `useGetCCICodes`.
 */

export function useGetCCICodes(searchValue?: string) {
  const client = useRequestProvider();

  return useQuery(['ccis-codes'], {
    queryFn: async () => {
      return await getCCICodes(client, searchValue);
    }
  });
}
